const SELECTORS = {
  section: '[data-product-recs-carousel]',
  grid: '[data-grid]',
  prev: '.product-recs-carousel__arrow.prev',
  next: '.product-recs-carousel__arrow.next',
  progressFill: '.product-recs-carousel__progress-fill',
};

const updateProgressBar = (grid, progressBar, isInit = false) => {
  if (!progressBar) return;

  const scrollLeft = grid.scrollLeft;
  const scrollWidth = grid.scrollWidth;
  const clientWidth = grid.clientWidth;
  const maxScroll = scrollWidth - clientWidth;

  if (maxScroll <= 0) {
    progressBar.style.width = '100%';
    progressBar.style.left = '0%';
    return;
  }

  const barWidthPercent = (clientWidth / scrollWidth) * 100;
  const barLeftPercent = isInit || scrollLeft < 60 ? 0 : (scrollLeft / scrollWidth) * 100;

  progressBar.style.width = `${barWidthPercent}%`;
  progressBar.style.left = `${barLeftPercent}%`;
};

const scheduleProgressUpdate = (grid, progressBar) => {
  if (grid.dataset.progressTicking === 'true') return;

  grid.dataset.progressTicking = 'true';
  requestAnimationFrame(() => {
    updateProgressBar(grid, progressBar);
    grid.dataset.progressTicking = 'false';
  });
};

const initOne = (sectionEl) => {
  if (!sectionEl) return;

  const grid = sectionEl.querySelector(SELECTORS.grid);
  if (!grid) return;
  const progressBar = sectionEl.querySelector(SELECTORS.progressFill);

  // Idempotency: we re-run init after AJAX swaps innerHTML
  if (grid.dataset.carouselInitialized === 'true') {
    updateProgressBar(grid, progressBar, true);
    return;
  }

  const prevBtn = sectionEl.querySelector(SELECTORS.prev);
  const nextBtn = sectionEl.querySelector(SELECTORS.next);

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      grid.scrollBy({ left: -grid.clientWidth, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      grid.scrollBy({ left: grid.clientWidth, behavior: 'smooth' });
    });
  }

  grid.addEventListener(
    'scroll',
    () => {
      scheduleProgressUpdate(grid, progressBar);
    },
    { passive: true }
  );

  window.addEventListener(
    'resize',
    () => {
      scheduleProgressUpdate(grid, progressBar);
    },
    { passive: true }
  );

  grid.dataset.carouselInitialized = 'true';
  updateProgressBar(grid, progressBar, true);
};

const initAll = () => {
  const sections = document.querySelectorAll(SELECTORS.section);
  for (const sectionEl of sections) initOne(sectionEl);
};

// Init on initial load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

// Re-init when Shopify theme editor loads/reorders sections
document.addEventListener('shopify:section:load', initAll);

document.addEventListener('shopify:section:reorder', initAll);

document.addEventListener('shopify:section:select', initAll);

// Re-init when product-recommendations swaps innerHTML after fetching
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof HTMLElement)) continue;

      if (node.matches?.(SELECTORS.section)) {
        initOne(node);
        continue;
      }

      const nestedSections = node.querySelectorAll?.(SELECTORS.section);
      if (nestedSections?.length) {
        for (const sectionEl of nestedSections) initOne(sectionEl);
        continue;
      }

      const sectionEl = node.closest?.(SELECTORS.section);
      if (sectionEl) initOne(sectionEl);
    }
  }
});

observer.observe(document.documentElement, {
  subtree: true,
  childList: true,
});
